<template>
    <CustomMenu
        v-model="menu"
        right
        hideTransitionSlider
        :menuWidth="160"
        :maxHeight="200"
    >
        <template #activator>
            <div
                class="w-8 h-8 flex items-center justify-center rounded-1.25 border transition-all cursor-pointer"
                :class="menu
                    ? 'bg-purple-50 dark:bg-blue-770 border-purple dark:border-blue-760 text-gray-370 dark:text-white'
                    : 'bg-purple-70 dark:bg-blue-780 border-transparent dark:border-blue-760 text-gray-370 dark:text-white hover:bg-purple-50 dark:hover:bg-blue-770'"
                @click="menu = !menu"
            >
                <HelpCircleIcon />
            </div>
        </template>

        <template #dropdown>
            <div
                class="py-1 bg-white dark:bg-black-370 border border-gray-100 dark:border-blue-720 rounded-1.25 shadow-notifications"
                @click.stop
            >
                <button
                    class="w-full flex items-center gap-x-2 py-2 px-3 text-xs text-gray-370 dark:text-white hover:text-gray-370 dark:hover:text-white hover:bg-purple-70 dark:hover:bg-blue-770 transition-colors cursor-pointer"
                    @click="onFeedback"
                >
                    <span class="w-5 flex items-center justify-center text-gray-200">
                        <FeedbackIcon />
                    </span>

                    <span class="font-medium dark:font-normal whitespace-nowrap">Leave Feedback</span>
                </button>

                <button
                    data-featurebase-changelog
                    data-featurebase-changelog-placement="bottom-end"
                    class="w-full flex items-center gap-x-2 py-2 px-3 text-xs text-gray-370 dark:text-white hover:text-gray-370 dark:hover:text-white hover:bg-purple-70 dark:hover:bg-blue-770 transition-colors cursor-pointer"
                >
                    <span class="w-5 flex items-center justify-center text-gray-200">
                        <LastChanges />
                    </span>

                    <span class="font-medium dark:font-normal whitespace-nowrap">Latest Changes</span>

                    <span id="fb-update-badge"></span>
                </button>

                <button
                    class="w-full flex items-center gap-x-2 py-2 px-3 text-xs text-gray-370 dark:text-white hover:text-gray-370 dark:hover:text-white hover:bg-purple-70 dark:hover:bg-blue-770 transition-colors cursor-pointer"
                    @click="onHelp"
                >
                    <span class="w-5 flex items-center justify-center text-gray-200">
                        <HelpIcon />
                    </span>

                    <span class="font-medium dark:font-normal whitespace-nowrap">Help Center</span>
                </button>
            </div>
        </template>
    </CustomMenu>
</template>

<script setup>
import { ref } from 'vue'

import CustomMenu from '@/components/menu/CustomMenu/CustomMenu.vue'
import HelpCircleIcon from '@/components/icons/HelpCircleIcon.vue'
import FeedbackIcon from '@/components/icons/navigations/FeedbackIcon.vue'
import LastChanges from '@/components/icons/navigations/LastChanges.vue'
import HelpIcon from '@/components/icons/navigations/HelpIcon.vue'

import { openFeedbackWidget } from '@/helpers/featurebase-helper'

const menu = ref(false)

function closeMenu() {
    menu.value = false
}

function onFeedback() {
    openFeedbackWidget()
    closeMenu()
}

function onHelp() {
    window.open(`${import.meta.env.VITE_SITE_LINK}help-center/`, '_blank')
    closeMenu()
}
</script>
